import { api, searchUSDA } from "../lib/api";

export const suggestIngredients = async (dishName, servings = 2) => {
  const { data } = await api.post(`/recipes/suggest-ingredients`, {
    dish_name: dishName,
    servings,
  });
  return data;
};

// Resolve a suggestion to an actual USDA food (first match)
export const resolveSuggestion = async (suggestion) => {
  const foods = await searchUSDA(suggestion.search_query, 5);
  // Prefer Foundation/SR Legacy/Survey over Branded for cleaner per-100g values
  const order = { "Foundation": 0, "SR Legacy": 1, "Survey (FNDDS)": 2, "Branded": 3 };
  const sorted = [...foods].sort(
    (a, b) => (order[a.data_type] ?? 9) - (order[b.data_type] ?? 9)
  );
  return sorted[0] || null;
};
